<template>
  <div id="latest-news-header" @mouseover="hovering = true" @mouseout="hovering = false">
    <div class="row">
      <div class="col-6">
        <h6>
          <a :href="window.contextPath + '/article/latest.html'">
            <template>{{ bundle.id_10859 }}</template>
            <i class="fa-light fa-chevron-right d-md-none ms-2"></i>
          </a>
        </h6>
      </div>
      <div class="col-6 text-end dots-and-arrows">
        <a href="#"
           v-for="i in numberOfSlides"
           :key="i"
           @click.prevent="jumpToSlide(i)"
           class="dot"
           :class="{'active': i == currentSlide}">
          <i class="fa-solid fa-circle"/>
        </a>
        <a href="#" @click.prevent="previousSlide" class="arrow">
          <i class="fa-light fa-angle-left"/>
        </a>
        <a href="#" @click.prevent="nextSlide" class="arrow">
          <i class="fa-light fa-angle-right"/>
        </a>
      </div>
    </div>
    <div>
      <transition :name="slideDirection" mode="out-in">
        <div :key="currentSlide" class="row">
          <div v-for="(article, index) in currentNews" :key="index" class="col-4">
            <smart-date :value="parseMillis(article.created)"
                        :label="bundle.id_12399"
                        :today-label="bundle.id_12396"
                        :yesterday-label="bundle.id_12397"
                        :tomorrow-label="bundle.id_12398"
                        :capitalize="true"
                        :year-format="bundle.id_12019"
                        :date-format="bundle.id_12395"
                        :time-format="bundle.id_12020"
                        :locale="window.vars.iso_639_1">
              <template v-slot:prepend=""><i class="fa-solid fa-circle"></i></template>
            </smart-date>
            <a :href="window.contextPath + '/article/view/' + article.id + '/' + slugUtil.withUnderscores(article.headline)" :title="article.headline">
              {{ article.headline }}
            </a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "latest-news",
  props: {
    value: {
      type: Array,
      required: true
    },
    autoRotate: {
      type: Boolean,
      default: false
    },
    rotationSpeed: {
      type: Number,
      default: 20000
    }
  },
  data: function () {
    return {
      bundle: {
        id_10859: "Latest news",
        id_12399: "{0} at {1}",
        id_12396: "Today",
        id_12397: "Yesterday",
        id_12398: "Tomorrow",
        id_12019: "MMMM d, yyyy",
        id_12395: "MMMM d",
        id_12020: "HH:mm",
      },
      slugUtil: Vue.$slugUtil,
      hovering: false,
      interval: null,
      slideDirection: "",
      currentSlide: 1,
      currentSize: 3
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  },
  mounted: function () {
    this.startRotation();
  },
  beforeDestroy: function () {
    this.stopRotation();
  },
  computed: {
    numberOfSlides: function () {
      return Math.ceil(this.value.length / this.currentSize);
    },
    currentNews: function () {
      return this.value.slice(
          (this.currentSlide - 1) * this.currentSize,
          ((this.currentSlide - 1) * this.currentSize) + this.currentSize
      );
    }
  },
  watch: {
    hovering: function (newValue) {
      if (newValue) {
        this.stopRotation();
      } else {
        this.startRotation();
      }
    }
  },
  methods: {
    startRotation: function () {
      if (this.autoRotate && !this.interval) {
        this.interval = setInterval(() => {
          this.nextSlide();
        }, this.rotationSpeed);
      }
    },
    stopRotation: function () {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    jumpToSlide: function (newSlide) {
      if (this.currentSlide < newSlide) {
        this.slideDirection = 'slide-left';
      } else if (this.currentSlide > newSlide) {
        this.slideDirection = 'slide-right';
      }
      this.currentSlide = newSlide;
    },
    previousSlide: function () {
      this.slideDirection = 'slide-right';
      if (this.currentSlide > 1) {
        this.currentSlide--;
      } else {
        this.currentSlide = this.numberOfSlides;
      }
    },
    nextSlide: function () {
      this.slideDirection = 'slide-left';
      if (this.currentSlide < this.numberOfSlides) {
        this.currentSlide++;
      } else {
        this.currentSlide = 1;
      }
    },
    parseMillis: function (millis) {
      return Vue.$luxon.DateTime.fromMillis(millis);
    }
  }
}
</script>

<style scoped lang="less">

//.slide-left-enter-active,
//.slide-left-leave-active {
//  transition: all .1s ease;
//}
//
//.slide-left-enter,
//.slide-right-leave-to {
//  opacity: 0;
//  //transform: translateX(100%);
//  transform: translateX(2rem);
//}
//
//.slide-right-enter-active,
//.slide-right-leave-active {
//  transition: all .1s ease;
//}
//
//.slide-right-enter,
//.slide-left-leave-to {
//  opacity: 0;
//  //transform: translateX(-100%);
//  transform: translateX(-2rem);
//}

#latest-news-header {
  & > div {
    padding: 0 1.25rem;

    @media (min-width: 768px) {
      padding: 0;
    }

    &:first-child {
      //width: 100%; // Without this the margin of the row class seems to cause horizontal scrolling on phones

      h6 {
        color: var(--nm-grey-60);
        margin: 0 0 1.5rem 0;
      }
      h6, h6 a {
        font-size: 1.125rem;
        font-weight: 600;
      }

      a {
        color: var(--nm-black);
        &:active, &:hover {
          color: var(--nm-black);
          text-decoration: underline;
        }
      }

      .dots-and-arrows {
        display: none;

        @media (min-width: 768px) {
          display: block;
        }
      }

      .dot {
        color: var(--nm-grey-10);
        font-size: .4375rem;
        vertical-align: middle;

        &.active {
          color: var(--nm-grey-80);
        }

        & + .dot {
          margin-left: .75rem;
        }
      }

      .arrow {
        color: var(--nm-grey-60);
        font-size: 1.75rem;
        line-height: 1.75rem;
        margin-left: 1.5rem;
        vertical-align: middle;
      }
    }

    &:last-child {
      -ms-overflow-style: none;
      overflow: auto;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      @media (min-width: 768px) {
        overflow: initial;
      }

      & > div {
        width: 240vw;

        @media (min-width: 768px) {
          width: auto;
        }
      }

      time {
        color: var(--nm-grey-60);
        display: block;
        font-size: .875rem;
        font-weight: 500;
        margin: 0 0 .375rem 0;

        i {
          font-size: .25rem;
          line-height: .875rem;
          margin-right: .375rem;
          vertical-align: middle;
        }
      }

      a {
        color: var(--nm-black);
        //display: block;
        font-size: 1rem;
        font-weight: 600;

        // This is for automatically limiting us to 2 lines of text by enforcing a line-height and setting a height.
        // The webkit syntax used here is supported by almost all browsers. Known exceptions are IE 6-11 and Opera Mini.
        line-height: 1.5rem;
        height: 3rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &:active, &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>